<template>
  <div >
    <button type="button" :id="id+`-modalButton`" class="btn btn-primary" data-bs-toggle="modal" :data-bs-target="`#${id}-customModal`"
            style="display: none" @click="$emit(`open`)"></button>
    <div class="modal fade" :id="id+`-customModal`" tabindex="-1" :aria-labelledby="id+`-customModalLabel`" aria-hidden="true">
      <div :class="`modal-dialog modal-${size}`">
        <div class="modal-content" v-if="!isForm ">
          <div class="modal-header">
            <h1 class="modal-title fs-5" :id="id+`-customModalLabel`">{{ title }}</h1>
            <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
          </div>
          <div class="modal-body">
            <slot  />
          </div>
          <div class="modal-footer">
            <button type="button" @click="$emit(`close`)" :id="id+`-closeModal`" class="btn btn-secondary" data-bs-dismiss="modal">Close</button>
          </div>
        </div>
        <div class="modal-content" v-else>
          <div class="modal-header">
            <h1 class="modal-title fs-5" :id="id+`-customFormModalLabel`">{{ title }}</h1>
            <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
          </div>
          <form @submit.prevent="submitForm">
            <div class="modal-body">
              <slot  />
            </div>
            <div class="modal-footer">
              <button type="submit" class="btn btn-primary">Submit</button>
              <button type="button" @click="$emit(`close`)" :id="id+`-closeFormModal`" class="btn btn-secondary" data-bs-dismiss="modal">Close</button>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "CustomModal",
  created() {
    this.id = `modal-`+generateUUID()
  },
  mounted() {
    if (this.$el) {
      document.body.appendChild(this.$el);
    }
  },
  destroyed() {
    if (this.$el && this.$el.parentNode) {
      this.$el.parentNode.removeChild(this.$el);
    }
  },
  data(){
    return {
      id : null,
    }
  },
  props: {
    isForm : {
      type : Boolean,
      required: false,
      default : false,
    },
    title: {
      type: String,
      required: true,
    },
    size : {
      type: String,
      required: false,
      default : "xl"
    }
  },
  methods : {
    openModal(){
      $utils.hideLoading();
      document.getElementById(this.id+`-modalButton`).click();
    },
    closeModal(){
      if (this.isForm){
        return document.getElementById(this.id+`-closeFormModal`).click();
      }
      return document.getElementById(this.id+`-closeModal`).click();
    },
    submitForm(){
      this.closeModal();
      this.$emit(`submit`);
    }
  }
}
</script>

<style scoped>
.modal-content {
  background: var(--card-bg);
  border: var(--card-border);
  border-radius: 16px; /* Increased border-radius for modern look */
  box-shadow: var(--card-shadow); /* Consistent shadow */
  color: var(--text-primary);
  transition: var(--transition-speed); /* Consistent transition */
  animation: fadeIn 0.3s ease;
}

.modal-header {
  border-bottom: 1px solid var(--card-border); /* Consistent border */
  padding: 18px 24px; /* Adjusted padding */
}

.modal-footer {
  border-top: 1px solid var(--card-border); /* Consistent border */
  padding: 18px 24px; /* Adjusted padding */
  display: flex;
  justify-content: flex-end;
  gap: 10px; /* Spacing between buttons */
}

.modal-title {
  color: var(--text-primary);
  font-weight: 700; /* Bolder title */
  font-size: 1.4rem; /* Larger title */
}

.btn-close {
  background: none; /* Remove default background */
  border: none;
  font-size: 1.5rem; /* Larger icon */
  color: var(--text-secondary); /* Softer color */
  opacity: 1; /* Always full opacity unless disabled */
  transition: var(--transition-speed);

  &:hover {
    color: var(--accent-electric-blue); /* Hover effect */
    transform: rotate(90deg); /* Rotate on hover */
  }
}

.btn-primary {
  background: linear-gradient(135deg, var(--accent-electric-blue), var(--accent-neon-purple)); /* Gradient background */
  color: white;
  border: none;
  border-radius: 10px; /* Consistent border-radius */
  padding: 10px 24px; /* Adjusted padding */
  font-weight: 600; /* Bolder text */
  box-shadow: var(--card-shadow); /* Consistent shadow */
  transition: var(--transition-speed);

  &:hover {
    background: linear-gradient(135deg, var(--accent-electric-blue-dark), var(--accent-neon-purple-dark)); /* Darker gradient on hover */
    transform: translateY(-2px);
    box-shadow: var(--card-shadow-hover);
  }

  &:active {
    transform: translateY(0);
  }
}

.btn-secondary {
  background: var(--secondary-button-bg); /* Use variable */
  color: var(--secondary-button-text);
  border: 1px solid var(--card-border); /* Consistent border */
  border-radius: 10px; /* Consistent border-radius */
  padding: 10px 24px; /* Adjusted padding */
  font-weight: 600; /* Bolder text */
  margin-left: 0; /* Remove default margin */
  transition: var(--transition-speed);

  &:hover {
    background: var(--secondary-button-hover-bg); /* Use variable */
    color: var(--secondary-button-hover-text); /* Ensure text color changes on hover */
    transform: translateY(-2px);
    box-shadow: var(--card-shadow-hover);
  }

  &:active {
    transform: translateY(0);
  }
}

.modal-body {
  padding: 24px; /* Adjusted padding */
}

/* Add fade-in animation for modal */
@keyframes fadeIn {
  from {
    opacity: 0;
    transform: translateY(20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.modal.fade .modal-dialog {
  transition: transform 0.3s ease-out;
  transform: translateY(-30px); /* Slightly more pronounced initial transform */
}

.modal.show .modal-dialog {
  transform: translateY(0);
}
</style>
